"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransactionSize = void 0;
const transaction_1 = require("./serialization/transaction");
exports.getTransactionSize = (transaction) => {
    const tx = Object.assign(Object.assign({}, transaction), { witnesses: transaction.witnesses.map(wit => (typeof wit === 'string' ? wit : transaction_1.serializeWitnessArgs(wit))) });
    const VIRTUAL_COST = 4;
    const serializedTransaction = transaction_1.serializeTransaction(tx);
    return serializedTransaction.slice(2).length / 2 + VIRTUAL_COST;
};
exports.default = { getTransactionSize: exports.getTransactionSize };
//# sourceMappingURL=sizes.js.map